import { timelineItemClasses } from "@mui/lab";
import Timeline from "@mui/lab/Timeline";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineDot from "@mui/lab/TimelineDot";
import { Avatar, Box, Typography } from "@mui/material";
import { FC, ReactElement } from "react";
import { tokens } from "@/tokens";
import usersAvatar from "@/assets/images/sidebar/users.png";
import {
  StyledListItemText,
  StyledTimelineContent,
  StyledTimelineItem,
  StyledTimelineSeparator,
} from "./style";

const Changelog: FC = (): ReactElement => {
  const changeLogData = [
    {
      id: 1,
      name: "Katie Sims",
      action: "changed the description of the event",
      event: "#Event Name goes here",
      time: "Today",
      avatar: usersAvatar,
    },
    {
      id: 2,
      name: "Katie Sims",
      action: "completed a task for",
      event: "#Event Name goes here",
      time: "Yesterday",
      avatar: usersAvatar,
    },
    {
      id: 3,
      name: "Katie Sims",
      action: "completed a task for",
      event: "#Event Name goes here",
      time: "Yesterday",
      avatar: usersAvatar,
    },
    {
      id: 4,
      name: "Corina McCoy",
      action: "updated the status of",
      event: "#Event Name goes here",
      time: "Yesterday",
      avatar: usersAvatar,
    },
    {
      id: 5,
      name: "Alex Buckmaster",
      action: "updated the status of",
      event: "#Event Name",
      time: "Yesterday",
      avatar: usersAvatar,
    },
  ];
  return (
    <Box p={4}>
      <Typography variant="h5">Change Log</Typography>
      <Typography variant="caption" color="#8D9299" gutterBottom>
        There are many variations of passages of Lorem Ipsum available, but the
        majority have suffered alteration.
      </Typography>

      <Timeline
        sx={{
          marginTop: "30px",
          padding: "0",
          [`& .${timelineItemClasses.root}:before`]: {
            flex: 0,
            padding: 0,
          },
        }}
      >
        <StyledTimelineItem>
          <StyledTimelineContent>
            {changeLogData.map((log) => (
              <StyledTimelineItem key={log.name}>
                <StyledTimelineSeparator>
                  <TimelineConnector />
                  <TimelineDot>
                    <Avatar
                      src={log.avatar}
                      alt={log.name}
                      sx={{ height: "30px", width: "30px" }}
                    />
                  </TimelineDot>
                  <TimelineConnector />
                </StyledTimelineSeparator>
                <StyledListItemText
                  primary={
                    <>
                      <Typography
                        variant="body2"
                        color={tokens.text.primary}
                        component="span"
                      >
                        {log.name}
                      </Typography>{" "}
                      {log.action}{" "}
                      <Typography
                        variant="body2"
                        color={tokens.brand.primary}
                        component="span"
                      >
                        {log.event}
                      </Typography>{" "}
                      • {log.time}
                    </>
                  }
                />
              </StyledTimelineItem>
            ))}
          </StyledTimelineContent>
        </StyledTimelineItem>
      </Timeline>
    </Box>
  );
};

export default Changelog;
